import { createApp } from "vue";
import Entry from "./components/Entry.vue";
import "./assets/tailwind.css";

let app = createApp({});

app.component("entry", Entry);

app.mount("#app");
